import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-valid"]
const _hoisted_2 = { class: "project-start-date__choice-chosen-date" }
const _hoisted_3 = { class: "project-start-date__sublabel" }
const _hoisted_4 = ["selected", "value"]
const _hoisted_5 = ["selected", "value"]
const _hoisted_6 = ["selected", "value"]
const _hoisted_7 = ["selected", "value"]

import {computed, ComputedRef, inject, onMounted, ref, Ref, watch} from 'vue';
    import {useVuelidate} from '@vuelidate/core';
    import {minValue, required} from '@vuelidate/validators';
    import {Vue3MqResource} from '@/common/types/vue3mq';
    import {getCalendarProperties} from '@malt/vue3-use';
    import {StartDateFlexibility, StartDateType} from '@/common/components/start-date/types';
    export interface ProjectStartDateModel {
        startDateType?: StartDateType;
        startDate?: Date;
        startDateFlexibility?: StartDateFlexibility;
    }

    interface PropsProjectStartDate {
        modelValue?: ProjectStartDateModel | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectStartDate',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const {datePattern, datePatternRegex, placeholder} = getCalendarProperties();

    const emits = __emit;
    const mq: Vue3MqResource | undefined = inject<Vue3MqResource>('mq');
    const props = __props;
    const isMobile: ComputedRef<boolean> = computed(() => !!mq?.mdMinus);
    const selectedStartDateType: Ref<StartDateType> = ref(props.modelValue?.startDateType || StartDateType.ASAP);
    const selectedStartDate: Ref<Date | undefined> = ref(props.modelValue?.startDate);
    const selectedFlexibility: Ref<StartDateFlexibility | undefined> = ref(
        props.modelValue?.startDateFlexibility || StartDateFlexibility.NOT_FLEXIBLE,
    );
    const selectedFlexible: Ref<boolean> = ref(
        !!props.modelValue?.startDateFlexibility && props.modelValue?.startDateFlexibility !== StartDateFlexibility.NOT_FLEXIBLE,
    );
    const minStartDate = computed<Date>(() => {
        return new Date(Date.now());
    });
    const isChosenDate = computed(() => selectedStartDateType.value === StartDateType.CHOSEN_DATE);

    const rules = computed(() => ({
        selectedStartDateType: {
            required,
        },
        selectedStartDate: {
            minValueValue: minValue(new Date().setHours(0, 0, 0, 0)),
            ...[isChosenDate.value && required],
        },
        selectedFlexible: {},
        selectedFlexibility: {
            ...[selectedFlexible.value && required],
        },
    }));

    const v$ = useVuelidate(rules, {selectedStartDate, selectedStartDateType, selectedFlexible, selectedFlexibility});

    onMounted(() => {
        props.modelValue?.startDateType && (selectedStartDateType.value = props.modelValue?.startDateType);
        selectedStartDate.value = props.modelValue?.startDate || new Date();
        props.modelValue?.startDateFlexibility && (selectedFlexibility.value = props.modelValue?.startDateFlexibility);
    });

    function handleFilter(event: string) {
        selectedFlexibility.value = event as StartDateFlexibility;
    }

    function emitUpdate() {
        emits('update:modelValue', {
            startDateType: selectedStartDateType.value,
            startDate: selectedStartDate.value,
            startDateFlexibility: selectedFlexibility.value,
        });
    }

    function handleFlexible(checked: boolean) {
        if (!checked) {
            selectedFlexibility.value = StartDateFlexibility.NOT_FLEXIBLE;
        }
        if (checked && selectedFlexibility.value === StartDateFlexibility.NOT_FLEXIBLE) {
            selectedFlexibility.value = StartDateFlexibility.MORE_OR_LESS_2_DAYS;
        }
    }

    function syncCheckboxToFlexibility() {
        selectedFlexible.value = selectedFlexibility.value !== StartDateFlexibility.NOT_FLEXIBLE ? true : false;
    }

    function init() {
        handleFlexible(selectedFlexible.value);
    }

    init();
    watch([selectedStartDateType, selectedStartDate, selectedFlexibility], emitUpdate, {immediate: true});
    watch(selectedFlexibility, syncCheckboxToFlexibility);

return (_ctx: any,_cache: any) => {
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_VJoyRadio = _resolveComponent("VJoyRadio")!
  const _component_MaltCalendar = _resolveComponent("MaltCalendar")!
  const _component_VJoyCheckbox = _resolveComponent("VJoyCheckbox")!
  const _component_VJoyFilterBarButton = _resolveComponent("VJoyFilterBarButton")!
  const _component_VJoyFilterBar = _resolveComponent("VJoyFilterBar")!
  const _component_VJoySelect = _resolveComponent("VJoySelect")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_VJoyRadioGroup = _resolveComponent("VJoyRadioGroup")!

  return (_openBlock(), _createElementBlock("div", {
    class: "project-start-date",
    "data-valid": _unref(v$).$invalid ? 'false' : 'true'
  }, [
    _createVNode(_component_VJoyLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.start.date.label')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_VJoyRadioGroup, { direction: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_VJoyRadio, {
          modelValue: selectedStartDateType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStartDateType).value = $event)),
          theme: "outline",
          value: _unref(StartDateType).ASAP,
          "data-testid": "project-start-date-choice-asap"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.start.date.radio.ASAP.label')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"]),
        _createVNode(_component_VJoyRadio, {
          modelValue: selectedStartDateType.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedStartDateType).value = $event)),
          theme: "outline",
          value: _unref(StartDateType).CHOSEN_DATE,
          "data-testid": "project-start-date-choice-chosen-date"
        }, {
          "expandable-content": _withCtx(() => [
            _createVNode(_component_VJoyLabel, {
              text: _ctx.$msg('client.project.component.start.date.radio.CHOSEN_DATE.starting.date.label')
            }, null, 8, ["text"]),
            _createVNode(_component_MaltCalendar, {
              datePattern: _unref(datePattern),
              datePatternRegex: _unref(datePatternRegex),
              minDate: minStartDate.value,
              modelValue: selectedStartDate.value,
              error: _unref(v$).selectedStartDate.$invalid,
              required: isChosenDate.value,
              class: "project-start-date__calendar",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (selectedStartDate.value = $event))
            }, null, 8, ["datePattern", "datePatternRegex", "minDate", "modelValue", "error", "required"]),
            _createVNode(_component_VJoyWrapper, null, {
              default: _withCtx(() => [
                _createVNode(_component_VJoyCheckbox, {
                  checked: selectedFlexible.value,
                  "onUpdate:checked": [
                    _cache[2] || (_cache[2] = ($event: any) => ((selectedFlexible).value = $event)),
                    handleFlexible
                  ],
                  label: _ctx.$msg('client.project.component.start.date.radio.CHOSEN_DATE.flexible.label'),
                  "data-testid": "project-start-date-flexible",
                  class: "project-start-date__flexible-checkbox"
                }, null, 8, ["checked", "label"]),
                (!isMobile.value)
                  ? (_openBlock(), _createBlock(_component_VJoyFilterBar, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_VJoyFilterBarButton, {
                          modelValue: selectedFlexibility.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedFlexibility).value = $event)),
                          active: selectedFlexibility.value === _unref(StartDateFlexibility).MORE_OR_LESS_2_DAYS,
                          value: _unref(StartDateFlexibility).MORE_OR_LESS_2_DAYS,
                          onFilter: handleFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.start.date.flexibility.MORE_OR_LESS_2_DAYS')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "active", "value"]),
                        _createVNode(_component_VJoyFilterBarButton, {
                          modelValue: selectedFlexibility.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedFlexibility).value = $event)),
                          active: selectedFlexibility.value === _unref(StartDateFlexibility).MORE_OR_LESS_1_WEEK,
                          value: _unref(StartDateFlexibility).MORE_OR_LESS_1_WEEK,
                          onFilter: handleFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.start.date.flexibility.MORE_OR_LESS_1_WEEK')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "active", "value"]),
                        _createVNode(_component_VJoyFilterBarButton, {
                          modelValue: selectedFlexibility.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedFlexibility).value = $event)),
                          active: selectedFlexibility.value === _unref(StartDateFlexibility).MORE_OR_LESS_1_MONTH,
                          value: _unref(StartDateFlexibility).MORE_OR_LESS_1_MONTH,
                          onFilter: handleFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.start.date.flexibility.MORE_OR_LESS_1_MONTH')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "active", "value"])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_VJoySelect, {
                      key: 1,
                      modelValue: selectedFlexibility.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedFlexibility).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          selected: selectedFlexibility.value === _unref(StartDateFlexibility).MORE_OR_LESS_2_DAYS,
                          value: _unref(StartDateFlexibility).NOT_FLEXIBLE
                        }, " - ", 8, _hoisted_4),
                        _createElementVNode("option", {
                          selected: selectedFlexibility.value === _unref(StartDateFlexibility).MORE_OR_LESS_2_DAYS,
                          value: _unref(StartDateFlexibility).MORE_OR_LESS_2_DAYS
                        }, _toDisplayString(_ctx.$msg('client.project.component.start.date.flexibility.MORE_OR_LESS_2_DAYS')), 9, _hoisted_5),
                        _createElementVNode("option", {
                          selected: selectedFlexibility.value === _unref(StartDateFlexibility).MORE_OR_LESS_1_WEEK,
                          value: _unref(StartDateFlexibility).MORE_OR_LESS_1_WEEK
                        }, _toDisplayString(_ctx.$msg('client.project.component.start.date.flexibility.MORE_OR_LESS_1_WEEK')), 9, _hoisted_6),
                        _createElementVNode("option", {
                          selected: selectedFlexibility.value === _unref(StartDateFlexibility).MORE_OR_LESS_1_MONTH,
                          value: _unref(StartDateFlexibility).MORE_OR_LESS_1_MONTH
                        }, _toDisplayString(_ctx.$msg('client.project.component.start.date.flexibility.MORE_OR_LESS_1_MONTH')), 9, _hoisted_7)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.start.date.radio.CHOSEN_DATE.label')) + " ", 1),
              _createElementVNode("span", _hoisted_3, "  - " + _toDisplayString(_ctx.$msg('client.project.component.start.date.radio.CHOSEN_DATE.label.info')), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "value"]),
        _createVNode(_component_VJoyRadio, {
          modelValue: selectedStartDateType.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedStartDateType).value = $event)),
          theme: "outline",
          value: _unref(StartDateType).UNKNOWN
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.start.date.radio.UNKNOWN.label')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"])
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}
}

})